import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=6fb27b21"
import script from "./Payment.js?vue&type=script&lang=js&external"
export * from "./Payment.js?vue&type=script&lang=js&external"
import style0 from "./Payment.vue?vue&type=style&index=0&id=6fb27b21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports